import styled from 'styled-components';

export const PauseTitle = styled.h3`
  text-align: center;
  position: relative;
  display: block;
`;

export const PauseDescription = styled.p`
  text-align: center;
  text-wrap: balance;
  position: relative;

  margin-top: 2rem;
  display: block;
`;

export const ButtonsContainer = styled.div`
  position: relative;
  margin-top: auto;
  display: block;

  button {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
